import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import "../../Assets/styles/customPhoneSelect.css";
import "react-phone-number-input/style.css";
import { colors } from "../../Assets/styles/colors";
import { useTranslate } from '@tolgee/react';
import CloseQcConfirmation from "./CloseQcConfirmation.js";
import QRCode from "react-qr-code";
import PrimaryButton from "../GenericComponents/PrimaryButton.js";



const QcChatDetailsView = ({
    conversationData,
    handleShareBtn,
    handleCloseChatBtn
}) => {
    const [closeConfirmOpen, setCloseConfirmOpen] = useState(false)
    const { t } = useTranslate();
    return (
        <AddNewGroupContainer>
            <Group>
                <TitleWrapper>
                    <h1>{t('general.name').toUpperCase()}</h1>
                </TitleWrapper>
                <OptionWrapper>
                    <CustomNameInput
                        readOnly
                        value={conversationData.quick_chat_name}
                        name="qcName"
                        maxLength={100}
                    ></CustomNameInput>
                </OptionWrapper>


            </Group>
            <Group>
                <SubtitleWrapper>
                    <p>{t('quick_chat.caution')}</p>
                </SubtitleWrapper>

            </Group>
            <Group>
                <TitleWrapper>
                    <h1>{t('chat_details.scan_easy_access').toUpperCase()}</h1>
                </TitleWrapper>
                <QrCodeWrapper>
                    <QRCode
                        style={{ height: "auto", width: "100px", background: "white", padding: "3px" }}
                        value={conversationData.url}
                    />
                </QrCodeWrapper>

            </Group>
            <Group>
                <TitleWrapper>
                    <h1>{t('chat_details.generated_link').toUpperCase()}</h1>
                </TitleWrapper>
                <InputCopyWrapper>
                    <CustomReadOnlyInput
                        readOnly
                        value={conversationData.url}
                    />

                </InputCopyWrapper>

            </Group>

            <Group>
                <Line>
                    <PrimaryButton
                        style={{ width: "100%", padding: "16px" }}
                        onClick={() => handleShareBtn(conversationData.url)}
                        text={t('quick_chat.copy_link')}
                    />
                </Line>
                <Line>
                    <CloseChatBtn onClick={() => setCloseConfirmOpen(true)}>
                        {t('quick_chat.close_chat')}
                    </CloseChatBtn>
                </Line>
            </Group>

            <CloseQcConfirmation
                open={closeConfirmOpen}
                handleClose={() => setCloseConfirmOpen(false)}
                handleRemove={() => handleCloseChatBtn(conversationData.id)}
            />
        </AddNewGroupContainer>
    )

};

export default QcChatDetailsView;

const AddNewGroupContainer = styled.div`
  background: ${({ theme }) => theme.menu.background};

  display: flex;
  flex-direction: column;
  padding: 24px 16px;
  gap: 25px;
  z-index: 1;
  width: 100%;
  height: 100%;
  overflow: auto;
`;

const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  h1 {
    color:${({ theme }) => theme.menu.secondaryTextColor};
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    text-transform: uppercase;
  }
`;
const SubtitleWrapper = styled.div`
display: flex;
justify-content: space-between;
p {
  color:${({ theme }) => theme.menu.infoText};
  font-size: 14px;
    font-weight: 500;
    line-height: 16px;
}
`

const OptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  background: ${({ theme }) => theme.menu.groupContentBackground};
  border-radius: 4px;
`;

const CustomInput = styled.input`
  background: none;
  border: none;
  color: ${({ theme }) => theme.menu.primaryTextColor};
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.40799999237060547px;
  &:focus-visible {
    outline: none;
  }
`;

const CustomNameInput = styled(CustomInput)`
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;

`;

const InputCopyWrapper = styled.div`
display:flex;
align-items:center;
border:1px solid ${({ theme }) => theme.sidebar.borderColor};
border-radius:4px;
overflow:hidden;
color:white;
width:100%;
`
const CustomReadOnlyInput = styled.input`
display:flex;
padding:13px 16px;
background:none;
outline:none;
color:${({ theme }) => theme.menu.primaryTextColor};
font-size: 16px;
font-weight: 500;
line-height: 22px;
text-align: left;
border:none;
width:100%;

`
const CloseChatBtn = styled.button`
display:flex;
justify-content:center;
align-items:center;
width:100%;
color: ${({ theme }) => theme.menu.deleteColor};
border-radius:4px;
border:1px solid ${({ theme }) => theme.menu.deleteColor};
padding:16px;
cursor:pointer;
border:1px solid ${colors.errorColor};
color:${colors.errorColor};
background:none;
font-size:14px;
line-height:100%;
font-weight:500;
`

const Line = styled.div`
display:flex;
gap:20px;
align-items:center;
`
const QrCodeWrapper = styled.div`
display:flex;
align-items:center;
justify-content:center;

`